import React, { Component } from 'react';
import Layout from './components/Layout/Layout';
import BurgerBuilder from './containers/BurgerBuilder/BurgerBuilder'
import Logout from './containers/Auth/Logout/Logout';

import { Route, Switch, withRouter, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actions from './store/actions/index';
import asyncComponent from './hoc/AsyncComponent/asyncComponent';

const asyncCheckout = asyncComponent(() => {
   return import('./containers/Checkout/Checkout');
})

const asyncOrders = asyncComponent(() => {
  return import('./containers/Orders/Orders');
})

const asyncAuth = asyncComponent(() => {
  return import('./containers/Auth/Auth');
})

class App extends Component {

  componentDidMount() {
    this.props.onTryAutoSignIn();
  }

  render() {

    let routes = (
          <Switch>
            <Route path="/" exact component={BurgerBuilder} />
            <Route path="/auth" exact component={asyncAuth} />
            <Redirect to="/"/>
          </Switch>
    )

    if(this.props.isAuthenticated) {
      routes = (
          <Switch>
            <Route path="/" exact component={BurgerBuilder} />
            <Route path="/orders" exact component={asyncOrders} />
            <Route path="/checkout" component={asyncCheckout} />
            <Route path="/auth" exact component={asyncAuth} />
            <Route path="/logout" exact component={Logout} />
            <Redirect to="/"/>
          </Switch>
      )
    }

    return (
      <div>
        <Layout>
          {
            // Without exact when other route are loaded the first route with / will also be loaded
            // but with switch only first matched will be loaded so order is imp
          }
          {routes}
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.auth.token !== null
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onTryAutoSignIn: () => dispatch(actions.authCheckState())
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
